import * as React from "react";
import {  Alert } from "@mui/material";

export const AlertModel = ({message}) => {

    return(
        <>
        <Alert severity="error">{message}: No data</Alert>
        </>
    )
}